import { memo } from "react";
import { cn } from "../../utils/cn";

interface MusterStationCountsCardProps {
  data: {
    id: number;
    title: string;
    count: number;
    bgColor: string;
  };
}

const MusterStationCountsCard = ({ data }: MusterStationCountsCardProps) => {
  const { title, count, bgColor } = data;

  return (
    <div
      className={cn(
        "flex flex-col text-white px-2 rounded-md gap-1 max-w-max cursor-default",
        bgColor,
      )}
    >
      <h1 className="text-white text-sm sm:text-[15px]">
        {title}: {count}
      </h1>
    </div>
  );
};

export default memo(MusterStationCountsCard);
